'use client';

// Error components must be Client Components
import { ErrorFallback } from '#components/ErrorFallback/ErrorFallback';

export default function ErrorPage({ error, reset }: { error: Error; reset: () => void }) {
  return <ErrorFallback error={error} resetErrorBoundary={reset} />;
}
